export const convertSnakeCaseIntoCamelCase = (str: string): string =>
	str.replace(/_[a-z]/g, (chars) => `${chars[1].toUpperCase()}`);
